var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "grid-view" }, [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c("el-alert", {
            staticClass: "unlock-ledger-alert",
            attrs: {
              title: _vm.$t("Clearing.UnlockLedgerTip"),
              type: "info",
              closable: false,
              "show-icon": ""
            }
          }),
          _c("div", { staticClass: "operations" }, [
            _c(
              "div",
              { staticClass: "filters" },
              [
                _c(
                  "el-form",
                  {
                    attrs: { inline: true },
                    nativeOn: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.onSearch($event)
                      }
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("Clearing.UnlockLedgerBatchNo") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "180px" },
                          attrs: {
                            placeholder:
                              _vm.$t("CargoMsg.Cargo_PlsInput") +
                              _vm.$t("Clearing.UnlockLedgerBatchNo"),
                            clearable: ""
                          },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.onSearch($event)
                            }
                          },
                          model: {
                            value: _vm.filter.batchNo,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "batchNo", $$v)
                            },
                            expression: "filter.batchNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Clearing.UnlockLedgerApplyUser")
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "150px" },
                          attrs: {
                            placeholder:
                              _vm.$t("CargoMsg.Cargo_PlsInput") +
                              _vm.$t("Clearing.UnlockLedgerApplyUser"),
                            clearable: ""
                          },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.onSearch($event)
                            }
                          },
                          model: {
                            value: _vm.filter.applyUser,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "applyUser", $$v)
                            },
                            expression: "filter.applyUser"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("Clearing.UnlockLedgerStatus") }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "140px" },
                            attrs: {
                              placeholder: _vm.$t("common.pleaseChoose"),
                              clearable: ""
                            },
                            model: {
                              value: _vm.filter.status,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "status", $$v)
                              },
                              expression: "filter.status"
                            }
                          },
                          _vm._l(_vm.statusOptions, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { value: item.value, label: item.label }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onSearch }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                        ),
                        _c("el-button", { on: { click: _vm.onReset } }, [
                          _vm._v(_vm._s(_vm.$t("common.btn.reset")))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "section grid-wrapper"
            },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.rows,
                    border: "",
                    height: "100%",
                    size: "mini"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "batchNo",
                      label: _vm.$t("Clearing.UnlockLedgerBatchNo"),
                      "min-width": "150",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "applyUser",
                      label: _vm.$t("Clearing.UnlockLedgerApplyUser"),
                      "min-width": "90",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderCount",
                      label: _vm.$t("Clearing.UnlockLedgerOrderCount"),
                      width: "80",
                      align: "center"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "reason",
                      label: _vm.$t("SeaExport.UnlockApplyReason"),
                      "min-width": "200",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("Clearing.UnlockLedgerDeclaredImpact"),
                      width: "120",
                      align: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.fmtAmount(scope.row.declaredProfitImpact)
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("Clearing.UnlockLedgerBeforeProfit"),
                      width: "110",
                      align: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.fmtAmount(scope.row.unlockBeforeProfit)
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("Clearing.UnlockLedgerAfterProfit"),
                      width: "110",
                      align: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.fmtAmount(scope.row.unlockAfterProfit))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("Clearing.UnlockLedgerActualImpact"),
                      width: "120",
                      align: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.fmtAmount(scope.row.actualProfitImpact)
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("Clearing.UnlockLedgerStatus"),
                      width: "90",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.statusTagType(scope.row.status),
                                  size: "mini"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.statusText(scope.row.status)) +
                                    " "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("Clearing.UnlockLedgerRelockTime"),
                      width: "150",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.fmtTime(scope.row.planRelockTime))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("Clearing.UnlockLedgerApplyTime"),
                      width: "150",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(_vm._s(_vm.fmtTime(scope.row.applyTime)))
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("Clearing.UnlockLedgerManualRemarks"),
                      "min-width": "150"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.manualLockRemarks
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.formatManualRemarks(
                                        scope.row.manualLockRemarks
                                      ),
                                      placement: "top",
                                      "popper-class":
                                        "unlock-manual-remarks-tooltip"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "manual-remarks-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatManualRemarks(
                                              scope.row.manualLockRemarks
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _c("span", { staticClass: "--" }, [
                                  _vm._v("--")
                                ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.total > 0,
                    expression: "total > 0"
                  }
                ],
                attrs: {
                  total: _vm.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  "page-sizes": [10, 20, 30, 50, 100]
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }